// What the team did during the Team free week, shown right before the owner picks a plan.
export default function TrialRecap({ recap, testid = "team-trial-recap" }) {
  if (!recap) return null;
  const cells = [["Listed by your team", recap.listed], ["Drafts your team made", recap.made], ["Sales", recap.sold], ["Revenue", `$${Number(recap.revenue).toFixed(2)}`]];
  return (
    <div className="mt-2 grid grid-cols-2 gap-1.5" data-testid={testid}>
      {cells.map(([k, v]) => (
        <div key={k} className="rounded-md bg-white/80 px-2 py-1.5 text-center">
          <p className="font-mono text-base font-bold text-slate-900" data-testid={`${testid}-${k.split(" ")[0].toLowerCase()}`}>{v}</p>
          <p className="text-[10px] text-slate-500">{k}</p>
        </div>
      ))}
    </div>
  );
}
